/**
 * aggregation-subject-context-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link AggregationSubjectContextRequest} to request a
 * subject included among the results for a particular aggregation report.
 * The server responds with an {@link SubjectContextResponse} that carries the
 * opaque identifier for the requested object.
 */
export class AggregationSubjectContextRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_AGGREGATION_SUBJECT_CONTEXT;
  public static tag : MessageTag = MessageTag.REQ_AGGREGATION_SUBJECT_CONTEXT;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_SUBJECT_CONTEXT);
  }

  /**
   * Construct a new {@link AggregationSubjectContextRequest}.
   */
  constructor (public aggregationId : number, public itemId : number)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/aggregation/aggregation-subject-context-request.ts